import React, { useCallback, useState } from "react";
import {
  PurchasedModalContents,
  ContentsWrap,
  ModalCloseButton,
  PriceLabel,
  PurchasedRequest,
  SelectedNameLabel,
  SelectedNameWrap,
  SelectedSpecItem,
  SelectedSpecWrap,
  CalendarSettingModalWrap,
  SelectedGBLabel,
  PriceLabelWrap,
  CloseButton,
  SpecLabel,
  DoubleLinePriceLabel,
} from "./elements";
import { Spec } from "../PurchasedList";
import { useNavigate } from "react-router-dom";
import Close from "../../assets/images/close.svg";

export interface CheckBox {
  label: string;
  checked: boolean;
}

export interface Props {
  selectedName: string;
  selectSpec: Spec | undefined;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PurchasedModal: React.FC<Props> = ({
  selectedName,
  selectSpec,
  setIsModalOpen,
}) => {
  const navigate = useNavigate();
  const [selectedCondition, setSelectedCondition] = useState("");

  const onModalClose = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const onPurchasedRequest = useCallback(
    (condition: string) => {
      setSelectedCondition(condition);
      navigate("/purchased_form", {
        state: { name: selectedName, gb: selectSpec?.gb, condition: condition },
      });
      setIsModalOpen(false);
    },
    [navigate, selectSpec?.gb, selectedName, setIsModalOpen]
  );

  if (!selectSpec) {
    return null;
  }

  return (
    <CalendarSettingModalWrap>
      <PurchasedModalContents>
        <ModalCloseButton onClick={onModalClose}>
          <CloseButton src={Close} />
        </ModalCloseButton>
        <ContentsWrap>
          <SelectedNameWrap>
            <SelectedNameLabel>{selectedName}</SelectedNameLabel>
            <SelectedGBLabel>{selectSpec.gb}</SelectedGBLabel>
          </SelectedNameWrap>
          <SelectedSpecWrap>
            <SelectedSpecItem>
              <PriceLabelWrap>
                <SpecLabel>新品同等傷なし</SpecLabel>
                <DoubleLinePriceLabel>
                  ~
                  {(
                    parseFloat(selectSpec.noScratches.replace(/[^\d.]/g, "")) *
                    0.9
                  ).toFixed(0)}
                  円
                </DoubleLinePriceLabel>
                <PriceLabel>{selectSpec.noScratches}</PriceLabel>
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("noScratches")}
              >
                申し込みページへ
              </PurchasedRequest>
            </SelectedSpecItem>
            <SelectedSpecItem>
              <PriceLabelWrap>
                <SpecLabel>若干傷あり</SpecLabel>
                <DoubleLinePriceLabel>
                  ~
                  {(
                    parseFloat(
                      selectSpec.someScratches.replace(/[^\d.]/g, "")
                    ) * 0.9
                  ).toFixed(0)}
                  円
                </DoubleLinePriceLabel>
                <PriceLabel>{selectSpec.someScratches}</PriceLabel>
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("someScratches")}
              >
                申し込みページへ
              </PurchasedRequest>
            </SelectedSpecItem>
            <SelectedSpecItem>
              <PriceLabelWrap>
                <SpecLabel>画面割れ</SpecLabel>
                <DoubleLinePriceLabel>
                  ~
                  {(
                    parseFloat(
                      selectSpec.crackedScreen.replace(/[^\d.]/g, "")
                    ) * 0.9
                  ).toFixed(0)}
                  円
                </DoubleLinePriceLabel>
                <PriceLabel>{selectSpec.crackedScreen}</PriceLabel>
              </PriceLabelWrap>
              <PurchasedRequest
                onClick={() => onPurchasedRequest("crackedScreen")}
              >
                申し込みページへ
              </PurchasedRequest>
            </SelectedSpecItem>
          </SelectedSpecWrap>
        </ContentsWrap>
      </PurchasedModalContents>
    </CalendarSettingModalWrap>
  );
};

PurchasedModal.displayName = "PurchasedModal";
